define("powergen/adapters/score",
  [],
  function() {
    "use strict";
    var ScoreAdapter;

    ScoreAdapter = DS.RESTAdapter.extend({
      find: function(store, type, id) {
        return $.getJSON("/api/score/" + id);
      },
      findAll: function(store, type) {
        return $.getJSON("/api/scores");
      },
      findQuery: function(store, type, query) {
        return $.getJSON("/api/scores/" + query.type);
      }
    });


    return ScoreAdapter;
  });